module.exports = __webpack_public_path__ + "img/h_s1e2_interactions_1.eaa1bd63.png";